import React from 'react'

export const ClickOutside = (
    props: {
      as: React.ElementType
      children: React.ReactNode
      onClickOutside: (event: MouseEvent | TouchEvent) => void
      exclude?: React.RefObject<HTMLElement>
    } & React.HTMLAttributes<HTMLElement>
  ) => {
    const ref = React.useRef<HTMLElement>(null)
  
    React.useEffect(() => {
      const handleClickOutside = (event: MouseEvent | TouchEvent) => {
        const refContainsTarget = (ref: React.RefObject<HTMLElement>) =>
          ref.current !== null && event.target instanceof HTMLElement && ref.current.contains(event.target)
        if (!refContainsTarget(ref) && (props.exclude === undefined || !refContainsTarget(props.exclude)))
          props.onClickOutside(event)
      }
  
      document.addEventListener('mousedown', handleClickOutside)
      document.addEventListener('touchstart', handleClickOutside)
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
        document.removeEventListener('touchstart', handleClickOutside)
      }
    }, [props.exclude])
  
    const { as: Tag, children, onClickOutside, exclude, ...htmlProps } = props
    return (
      <Tag {...htmlProps} ref={ref}>
        {props.children}
      </Tag>
    )
  }
  